import type { EChartsOption } from 'echarts';

/** Matches dashboard chart palettes (MultiLineChart, PieChart, EngagementRatesChart). */
export const DASHBOARD_LINE_COLORS = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444'];
export const DASHBOARD_PIE_COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];

export const USER_MESSAGE_COLOR = DASHBOARD_LINE_COLORS[0];
export const ASSISTANT_MESSAGE_COLOR = DASHBOARD_LINE_COLORS[1];

export const dashboardAxisTooltip: EChartsOption['tooltip'] = {
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  borderColor: '#e5e7eb',
  borderWidth: 1,
  borderRadius: 8,
  textStyle: {
    color: '#1f2937',
    fontSize: 12,
  },
};

export const dashboardPieTooltip: EChartsOption['tooltip'] = {
  trigger: 'item',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  textStyle: {
    color: '#ffffff',
    fontSize: 12,
  },
};

export function dashboardAreaGradient(color: string) {
  return {
    type: 'linear' as const,
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color },
      { offset: 1, color: 'transparent' },
    ],
  };
}

export const dashboardGrid = {
  left: '3%',
  right: '4%',
  bottom: '12%',
  top: '12%',
  containLabel: true,
};

export const dashboardCategoryAxis = {
  axisLine: { lineStyle: { color: '#d1d5db' } },
  axisLabel: { color: '#6b7280', fontSize: 11 },
  axisTick: { show: false },
};

export const dashboardValueAxis = {
  axisLine: { show: false },
  axisLabel: { color: '#6b7280', fontSize: 11 },
  splitLine: { lineStyle: { color: '#e5e7eb' } },
};
